import jQuery from "jQuery";
import * as common from "./common.js";
/*global FB*/

let ready = false;
let callbacksOnReady = [];

export function isCanvas() {
    return common.config.environment === "FACEBOOK";
}

export function onInit(response) {
    console.log("[w] on Facebook Init", response);

    if (!ready) {
        ready = true;
        while (callbacksOnReady.length > 0) callbacksOnReady.pop()();
        if (isCanvas()) {
            FB.Canvas.setAutoGrow();
            refreshToken();
        }
    }
}

export function doOnReady(callback) {
    if (ready) callback();
    else callbacksOnReady.push(callback);
}

export function getPageInfo(callback) {
    doOnReady(function () {

        console.log("[w] on getPageInfo");
        FB.Canvas.getPageInfo(function (info) {
            info.clientWidth = window.innerWidth;
            callback(info);
        });
    });
}

export function getLoginStatus() {
    return new Promise((resolve) => {
        FB.getLoginStatus(function (response) {
            resolve(response);
        });
    });
}

export function refreshToken() {
    return getLoginStatus()
        .then(response => {
            if (response.status !== "connected") {
                throw "the user must be connected";
            }

            let url = common.getApiUrl(`/facebook/game/token/refresh/${common.config.gameName}/${common.config.environment}`);
            return fetch(url, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: jQuery.param({
                    token: response.authResponse.accessToken,
                    expiredDate: response.authResponse.expiresIn,
                })
            });
        });
}

export function buyMobile(hash, pricepointId, amount, payoutBaseAmount, currency, virtualAmount, currencyType) {

    jQuery.colorbox.close();

    const params = {
        hash: hash,
        pricepointId: pricepointId,
        amount: amount,
        currency: currency,
        currencyType: currencyType,
        virtualAmount: virtualAmount,
        payoutBaseAmount: payoutBaseAmount
    };

    const url = common.getApiUrl(`/facebook/game/${common.config.gameName}/mobilePayment/${common.config.platformData.appId}`, params);

    const obj = {
        method: "pay",
        action: "purchaseitem",
        product: url,
        shortcut: "mobile",
        pricepoint_id: pricepointId
    };

    FB.ui(obj, function (e) {
        console.log("After buy", e);
    });
}

export function login() {
    return getLoginStatus()
        .then((response) => {
            if (response.status !== "connected") {
                top.location.href = common.config.platformData.authUrl;
                return;
            }
            return response;
        });
}